export enum CmrValidationAction {
  None = 0,
  NotifyFmsUser = 1,
  CpFeedbackInvalidSignature = 2,
  CpFeedbackInvalidDocument = 3,
}

export const CmrValidationActionLabel = new Map<CmrValidationAction, string>([
  [CmrValidationAction.CpFeedbackInvalidDocument, 'SHARED.CMR-NOT-RECOGNISED'],
  [CmrValidationAction.CpFeedbackInvalidSignature, 'SHARED.CMR-MISSING-SIGNATURE'],
]);
